<template>
  <div class="container fluid">
    <div class="mb-2">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="channelFilter != 'all'"
            :color="channelFilter == 'all' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="onChangeChannel('all')"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="channelFilter != 'facebook'"
            :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="onChangeChannel('facebook')"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="channelFilter != 'line'"
            :color="channelFilter == 'line' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="onChangeChannel('line')"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-right">
          <v-btn color="primary" outline depressed @click="showExportGroup = true">{{
            $t('Export')
          }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div class="mb-2">
      <date-filter
        v-model="selectedDate"
        :default-filter="'today'"
        @changeDate="onDateChanged"
      ></date-filter>
    </div>
    <div class="mt-5">
      <v-layout wrap>
        <v-flex xs4 class="pr-4">
          <div class="caption pb-2">{{ $t('timing') }}</div>
          <div class="d-flex">
            <CustomTimepicker
              name="starttime"
              :value="filter.timingFrom"
              overlay
              format="HH:mm"
              :placeholder="$t('from')"
              only-time
              class="pr-1 custom-time-picker"
              @onChange="
                (val) => {
                  filter.timingFrom = val
                }
              "
            >
            </CustomTimepicker>
            <CustomTimepicker
              name="endtime"
              :value="filter.timingTo"
              overlay
              format="HH:mm"
              :placeholder="$t('to')"
              only-time
              class="pl-1 custom-time-picker"
              @onChange="
                (val) => {
                  filter.timingTo = val
                }
              "
            >
            </CustomTimepicker>
          </div>
        </v-flex>
        <v-flex xs4>
          <div class="caption pb-2">{{ $t('conversation_grouping') }}</div>
          <v-autocomplete
            v-model="filter.conversationGrouping"
            :items="groupConversationOptions"
            item-text="name"
            item-value="id"
            label="name"
            :placeholder="$t('conversation_grouping')"
            solo
            outline
            flat
            clearable
            class="pr-1 custom-select-remove-border"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs4>
          <div class="caption pb-2">{{ $t('conversation_name') }}</div>
          <v-autocomplete
            v-model="filter.conversationName"
            :items="intentOptions"
            item-text="intentname"
            item-value="intentname"
            :placeholder="$t('conversation_name')"
            label="intentname"
            solo
            outline
            flat
            clearable
            class="pl-1 custom-select-remove-border"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 class="text-xs-right pt-3">
          <v-btn outline color="grey" @click="clearsearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn color="primary" @click="onsearch"><v-icon>search</v-icon>{{ $t('Search') }}</v-btn>
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :headers="headers"
      :items="data"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1 mt-4"
    >
      <!-- hide-actions -->
      <template #items="props">
        <tr>
          <td>{{ props.item.questiondata }}</td>
          <td class="text-sm-center">{{ props.item.count }}</td>
          <td class="text-sm-right">
            <v-btn flat icon ripple color="primary" @click="onShowDetails(props.item.questiondata)">
              <v-icon>search</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="mt-4 text-xs-center">
      <v-pagination
        v-model="pageNumber"
        :total-visible="6"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
    </div>

    <v-dialog v-model="detailsDialog" width="800px" persistent>
      <v-card class="pa-4">
        <v-data-table
          :headers="headersDetails"
          :items="dataDetailsWithQuestionData"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1 mt-4"
        >
          <!-- hide-actions -->
          <template #items="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>
                <span v-if="props.item.app == 'facebook'" style="color: #3b5998">
                  <em class="fab fa-facebook-square" />
                </span>
                <span v-if="props.item.app == 'line'" style="color: #00c300">
                  <em class="fab fa-line" />
                </span>
              </td>
              <td class="text-xs-center">
                {{ props.item.timestamp | DateFormat('DD/MM/YY HH:mm') }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center mt-3">
          <v-btn outline color="primary" @click="onCloseDetailDialog">
            {{ $t('close') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <ExportGroup
      v-model="showExportGroup"
      :total="totalExport"
      :filename="$t('conversation_details')"
      :limit="1000"
      @onExport="onExportConversation"
    ></ExportGroup>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker2.vue'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'
import ExportGroup from '@/components/elements/ExportGroup.vue'

export default {
  components: {
    DateFilter,
    CustomTimepicker,
    ExportGroup
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 50,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: this.$t('customer_says'), value: 'customer_says', sortable: false },
        { text: this.$t('count'), value: 'count', align: 'center', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      headersDetails: [
        { text: this.$t('Name'), value: 'name', sortable: false },
        { text: this.$t('Channel'), value: '', sortable: false },
        { text: this.$t('date_time'), value: 'timestamp', align: 'center', sortable: false }
      ],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      channelFilter: 'all',
      filter: {
        timingFrom: '',
        timingTo: '',
        conversationGrouping: '',
        conversationName: ''
      },
      search: null,
      data: [],
      loading: false,
      detailsDialog: false,
      groupConversationOptions: [],
      intentOptions: [],
      selectedQuestionData: null,
      dataDetailsWithQuestionData: [],
      loadingExport: false,
      showExportGroup: false,
      totalExport: 0
    }
  },

  computed: {
    ...mapGetters(['selectedBot']),
    timingOption() {
      let options = []
      for (let i = 0; i < 24; i++) {
        if (i < 10) {
          options.push(`0${i}:00`)
        } else {
          options.push(`${i}:00`)
        }
      }
      return options
    },
    pagelength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
    this.getIntent()
    this.getGroupConversation()
    this.getExportData(this.limit, this.offset, false)
  },
  methods: {
    async onExportConversation(callback) {
      if (callback) {
        let { limit, offset } = callback

        this.$store.dispatch('loading')
        const format_data = await this.getExportData(limit, offset, true)
        this.$store.dispatch('clear_loading')

        if (format_data) {
          callback.submitData(format_data)
        }

        this.loading = false
      }
    },
    getGroupConversation() {
      const vm = this
      const data = {
        pageid: vm.selectedBot.pageid
      }

      api.getGroupConversationByPageId(data, (err, response) => {
        if (err) {
          console.error(err)
          return
        }

        if (response && response.responsecode == 200) {
          vm.groupConversationOptions = response.groupsConversation
        }
      })
    },
    async getIntent() {
      const vm = this
      const params = {
        pageid: vm.selectedBot.pageid,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params })
        await handleResponse(response)
        const data = response.data.data
        if (data) {
          vm.intentOptions = data
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    getData() {
      const vm = this
      const data = {
        pageid: vm.selectedBot.pageid,
        startDate: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        endDate: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
        channel: vm.channelFilter,
        limit: vm.limit,
        offset: vm.offset
      }

      if (vm.filter.timingFrom) {
        Object.assign(data, { startTime: vm.filter.timingFrom })
      }
      if (vm.filter.timingTo) {
        Object.assign(data, { endTime: vm.filter.timingTo })
      }
      if (vm.filter.conversationGrouping) {
        Object.assign(data, { groupConversationId: vm.filter.conversationGrouping })
      }
      if (vm.filter.conversationName) {
        Object.assign(data, { intentName: vm.filter.conversationName })
      }

      vm.loading = true
      api.toaPaintGetConversationDetails(data, (err, response) => {
        if (err) {
          console.error(err)
          return
        }

        if (response && response.responsecode == 200) {
          vm.data = response.data
          vm.total = response.total
          vm.loading = false
        }
      })
    },
    getDetailsWithQuestionData() {
      const vm = this
      const data = {
        pageid: vm.selectedBot.pageid,
        startDate: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        endDate: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
        channel: vm.channelFilter,
        questionData: vm.selectedQuestionData,
        limit: vm.limit,
        offset: vm.offset
      }

      if (vm.filter.timingFrom) {
        Object.assign(data, { startTime: vm.filter.timingFrom })
      }
      if (vm.filter.timingTo) {
        Object.assign(data, { endTime: vm.filter.timingTo })
      }
      if (vm.filter.conversationGrouping) {
        Object.assign(data, { groupConversationId: vm.filter.conversationGrouping.id })
      }
      if (vm.filter.conversationName) {
        Object.assign(data, { intentName: vm.filter.conversationName.intentname })
      }

      vm.loading = true
      api.toaPaintGetConversationDetailsWithQuestionData(data, (err, response) => {
        if (err) {
          console.error(err)
          return
        }

        if (response && response.responsecode == 200) {
          vm.dataDetailsWithQuestionData = response.data
          vm.loading = false
        }
      })
    },
    async getExportData(limit, offset, isExport = false) {
      const vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        startDate: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        endDate: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
        channel: vm.channelFilter,
        limit: limit,
        offset: offset
      }

      if (vm.filter.timingFrom) {
        Object.assign(data, { startTime: vm.filter.timingFrom })
      }
      if (vm.filter.timingTo) {
        Object.assign(data, { endTime: vm.filter.timingTo })
      }
      if (vm.filter.conversationGrouping) {
        Object.assign(data, { groupConversationId: vm.filter.conversationGrouping.id })
      }
      if (vm.filter.conversationName) {
        Object.assign(data, { intentName: vm.filter.conversationName.intentname })
      }

      return new Promise((resolve, reject) => {
        api.toaPaintExportConversationDetails(data, (err, response) => {
          if (err) {
            reject(err)
          }

          if (response && response.data) {
            if (isExport) {
              const dataExport = response.data

              const json = dataExport.map((val) => {
                return {
                  ชื่อ: val['name'] ? val['name'] : '-',
                  ลูกค้าพิมพ์ว่า: val['questiondata'] ? val['questiondata'] : '-',
                  ช่องทาง: val['app'] ? val['app'] : '-',
                  กลุ่มของบทสนทนา: val['intentgroup'] ? val['intentgroup'] : '-',
                  ชื่อบทสนทนา: val['intentname'] ? val['intentname'] : '-',
                  วันเวลา: val['timestamp']
                    ? moment(val['timestamp']).format('DD/MM/YYYY HH:mm:ss')
                    : '-'
                }
              })
              resolve(json)
            } else {
              vm.totalExport = response.total
              reject(null)
            }
          }
        })
      })
    },
    onShowDetails(questiondata) {
      this.selectedQuestionData = questiondata
      this.getDetailsWithQuestionData()
      this.detailsDialog = true
    },
    onCloseDetailDialog() {
      this.detailsDialog = false
      this.selectedQuestionData = null
      this.dataDetailsWithQuestionData = []
    },
    onsearch() {
      this.pageNumber = 1
      this.offset = 0
      this.getData()
      this.getExportData(this.limit, this.offset, false)
    },
    clearsearch() {
      this.filter = {
        timingFrom: '',
        timingTo: '',
        conversationGrouping: '',
        conversationName: ''
      }
      this.onsearch()
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.getData()
      }
    },
    onDateChanged() {
      this.onsearch()
    },
    onChangeChannel(val) {
      this.channelFilter = val
      this.onsearch()
    }
  }
}
</script>

<style lang="scss">
.custom-time-picker input[type='text'][readonly='readonly'] {
  border-bottom: 0 !important;
}
.custom-select-remove-border input[type='text'] {
  border-bottom: 0 !important;
  margin: 0 !important;
}
.custom-select-remove-border input[type='text']:focus {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/toapaint/ConversationDetails.vue